<template>
  <div class="user-main">
    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="用户管理" name="first">
        <div> 
          <el-row :gutter="24">
            <el-form :model="user_info_table" ref="user_info_table" label-width="100px" @class="demo-user_info_table">
              
              <el-col :span='12'>
                <el-form-item label="用户名">
                  <el-input v-model="user_info_table.username" placeholder="请输入用户名" :disabled=bEditDisabled></el-input>
                  
                </el-form-item>
               
              </el-col>

              <el-col :span='12'>
                <el-form-item label="手机号">
                  <el-input v-model="user_info_table.phone_num" placeholder="请输入手机号码" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              
              <el-col :span="12">
                <el-form-item label="邮箱">
                  <el-input v-model="user_info_table.email" placeholder="请输入邮箱" :disabled=bEditDisabled></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="所属部门">
                  <el-input v-model="user_info_table.department_name" placeholder="部门" :disabled="true"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="员工身份">
                  <el-input v-if="user_info_table.is_super_admin" value="超级管理员" placeholder="员工身份" :disabled="true"></el-input>
                  <el-input v-else value="普通员工" placeholder="员工身份" :disabled="true"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="职位">
                  <el-select v-model="user_info_table.job_name" multiple placeholder="请选择岗位" :disabled="true" :style="{width: '100%'}">
                    <el-option
                      v-for="item in user_info_table.job_name"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="">
                  <el-button plain type="primary" @click="edit_user_info" size="small" icon="el-icon-edit" :style="{width: '100%'}">{{ sEditButtonName }}</el-button>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="">
                  <el-button plain type="primary" @click="save_user_info" size="small" icon="el-icon-check" :disabled=bEditDisabled :style="{width: '100%'}">保存</el-button>
                </el-form-item>
              </el-col>

            </el-form>
          </el-row>

        </div>
      </el-tab-pane>

      <el-tab-pane label="密码设置" name="second">
        <div> 
          <el-tag style="padding: 0px 16px;" type="warning"> 重置密码后,需要重新登录 </el-tag>
          <el-form :model="password_data" status-icon :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm" style="margin-top:30px">
            <el-form-item label="请输入原密码" prop="old_password" >
              <el-input type="password" v-model="password_data.old_password" autocomplete="off" :style="{width: '30%'}"></el-input>
            </el-form-item>
            <el-form-item label="请输入新密码" prop="password">
              <el-input type="password" v-model="password_data.password" autocomplete="off" :style="{width: '30%'}"></el-input>
            </el-form-item>
            <el-form-item label="请输入确认密码" prop="password_confirm">
              <el-input type="password" v-model="password_data.password_confirm" autocomplete="off" :style="{width: '30%'}"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      
      return {
        
        activeName: 'first',
        user_info_table:{},
        bEditDisabled: true,
        sEditButtonName: '编辑',
        
        password_data : {
          old_password: '',
          password: '',
          password_confirm: ''
        },

        rules: {
          old_password: [
            { required: true, message: '请输入原密码', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ],
          password_confirm: [
            { required: true, message: '请输入确认密码', trigger: 'blur' }
          ]
        }
      }
    },
    
    mounted() {
      this.refresh_user_info_table_data()
    },
    methods: {
      // 刷新用户信息表单数据
      async refresh_user_info_table_data() {
        // 当前用户id
        let id = window.sessionStorage.getItem('id')
        console.log(id)
        // 请求当前用户信息
        let res = await this.$axios.get('/api/users/' + id + '/')
        console.log(res)
        this.user_info_table = res.data
        console.log(this.user_info_table)
      },

      handleClick(tab, event) {
        this.resetForm('ruleForm')
      },

      // 编辑用户信息
      async edit_user_info() {
        this.bEditDisabled = !this.bEditDisabled
        this.sEditButtonName = this.bEditDisabled ? '编辑' : '取消编辑'
        if (this.bEditDisabled) {
          await this.refresh_user_info_table_data()
        }
      },

      // 保存用户信息
      async save_user_info() {
        let url = '/api/users/' + this.user_info_table.id + '/'
        await this.$axios.patch(url, this.user_info_table)
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.bEditDisabled = true
        this.sEditButtonName = '编辑'
        await this.refresh_user_info_table_data()
      },

      // 重置
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },

      // 提交
      submitForm(fromData) {

        // 校验新密码两次是否一致
        if (this.password_data.password !== this.password_data.password_confirm) {
          this.$message({
            message: '两次输入的密码不一致',
            type: 'warning'
          })
          return
        }
        this.$axios.patch('/api/change_password/' + this.user_info_table.id + '/', this.password_data).then(
          (res) => {
            this.$message({
              message: '修改成功,请重新登录',
              type: 'success'
            })
            // 退出登录删除token
            window.sessionStorage.removeItem('token')
            // 修改成功则重新登录
            this.$router.push('/login')
          }
        ).catch(
          (err) => {
            console.log(err)
            this.$message({
              message: ''  + err.response.data.message,
              type: 'error'
            })
          }
        )
      }
    }
  };
</script>

<style>
.user-main {
  padding: 12px 16px;
  
  /* margin-left: 20px; */
}

.tab-main {
  width: 300px;
  margin:0 auto
}

</style>